import { Button, Dropdown, Tooltip } from "antd";
import type { MenuProps } from "antd";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { currentLanguage, setLanguage } from "../i18n";

export function LanguageMenu() {
  const { t } = useTranslation();
  const language = currentLanguage();
  const currentLanguageLabel = language === "en-GB"
    ? t("common.britishEnglish")
    : t("common.simplifiedChinese");
  const items: MenuProps["items"] = [
    { key: "zh-CN", label: t("common.simplifiedChinese") },
    { key: "en-GB", label: t("common.britishEnglish") },
  ];

  return (
    <Dropdown
      menu={{
        items,
        selectable: true,
        selectedKeys: [language],
        onClick: ({ key }) => void setLanguage(key === "en-GB" ? "en-GB" : "zh-CN"),
      }}
      trigger={["click"]}
    >
      <Tooltip title={`${t("common.language")} · ${currentLanguageLabel}`}>
        <Button
          type="text"
          className="app-utility-button"
          icon={<Languages aria-hidden />}
          aria-label={t("common.language")}
        />
      </Tooltip>
    </Dropdown>
  );
}
